/**
 * removes nested edges > node structure, to simplify accessing small queries
 * that don't need pageInfo, etc.
 * @param {Object} data - Shopify GraphQL Product query response
 * @returns
 */
export default function unwrapProducts(data) {
  const formattedData = "edges" in data ? data : { edges: [{ node: data }] };

  return formattedData.edges.map(({ node }) => {
    const unwrapKeys = ["variants", "media"];
    unwrapKeys.forEach((key) => {
      if (key in node) {
        node[key] = node[key].edges.map(({ node }) => node);
      }
    });

    return node;
  });
}
